// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cta-text[data-v-688b4e2c]{border-bottom:1px solid transparent;transition:border-color .25s cubic-bezier(0.4, 0, 1, 1)}.cta-link[data-v-688b4e2c]{text-decoration:none;outline:0}.cta-link:hover .cta-text[data-v-688b4e2c],.cta-link:focus .cta-text[data-v-688b4e2c]{border-color:currentColor}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
